<template>
  <el-dialog append-to-body :visible.sync="visible" :title="formData.modelName || (!colData || !colData.id?$t('page.add'):$t('page.update'))"  :width="updateData.width" :close-on-click-modal="false" :before-close="beforeClose" :close-on-press-escape="false" class="dv_update">
    <el-form :model="formData" ref="dataForm" :style="{'max-height':maxHeight,'overflow-y':'scroll'}">
      <div v-for="(col,index) in formData.cols">
        <el-form-item :class="col.position" :required="getFieldRequired(col)" v-if="col.type != 10" :style="{'display': getFieldDisplay(col)}" :label="col.title" >

          <span v-if="col.type == 17">{{col.data}}</span>

          <!--普通input框 type:1-->
          <el-input :readonly="getFieldReadonly(col)" :disabled="col.disabled"  :type="col.textType" :autosize="true" v-if="!col.type || col.type == 1" @input="change()" @blur="col.data=$event.target.value.trim()" v-model="col.data" :placeholder="col.placeholder==null?col.title:col.placeholder"></el-input>

          <!--select框 type:2-->
          <el-select :disabled="getFieldReadonly(col)"  :multiple="col.multiple" @input="change()" @change="changeValue(updateModel,col,formData.cols)" v-if="col.type == 2" clearable  v-model="col.data" filterable :placeholder="col.title">
            <el-option v-if="col.optionList && col.optionList instanceof Array" v-for="option in col.optionList" :label="option.value" :value="col.isNumber?Number(option.key):option.key"></el-option>
            <el-option v-if="col.optionList && !(col.optionList instanceof Array)" v-for="(value,key) in col.optionList" :label="value" :value="col.isNumber?Number(key):key"></el-option>
            <el-option v-if="col.optionListArrRender" v-for="option in (col.optionListArrRender?col.optionListArrRender(updateModel,col):[])" :label="option.value" :value="col.isNumber?Number(option.key):option.key"></el-option>
            <el-option v-if="col.optionListObjRender" v-for="(value,key) in (col.optionListObjRender?col.optionListObjRender(updateModel,col):{})" :label="value" :value="col.isNumber?Number(key):key"></el-option>
          </el-select>

          <!--单选 type:3-->
          <el-radio-group  :disabled="getFieldReadonly(col) || col.disabled" v-if="col.type == 3" @input="change()"  v-model="col.data">
            <el-radio v-if="!col.button && col.optionList instanceof Array" v-for="option in col.optionList" :label="col.isNumber?Number(option.key):option.key">{{option.value}}</el-radio>
            <el-radio v-if="!col.button && !(col.optionList instanceof Array)" v-for="(value,key) in col.optionList" :label="col.isNumber?Number(key):key">{{value}}</el-radio>
            <el-radio-button  v-if="col.button && col.optionList instanceof Array" v-for="option in col.optionList" :label="col.isNumber?Number(option.key):option.key">{{option.value}}</el-radio-button>
            <el-radio-button v-if="col.button && !(col.optionList instanceof Array)" v-for="(value,key) in col.optionList" :label="col.isNumber?Number(key):key">{{value}}</el-radio-button>
          </el-radio-group>

          <!--复选框 type:4-->
          <el-checkbox :indeterminate="col.isIndeterminate" :disabled="getFieldReadonly(col)" v-if="col.type == 4 && col.hasCheckAll" v-model="col.checkAll" @change="(val)=>handleCheckAllChange(val,col)">{{col.checkAllName || $t('page.selectAll')}}</el-checkbox>
          <el-checkbox-group style="margin:auto 20px"  :disabled="getFieldReadonly(col) || col.disabled"  v-if="col.type == 4" @input="change()"  v-model="col.data" @change="(val)=>handleCheckedCitiesChange(val,col)">
            <el-checkbox v-if="col.optionList instanceof Array" v-for="option in col.optionList" :label="col.isNumber?Number(option.key):option.key">{{option.value}}</el-checkbox>
            <el-checkbox v-if="!(col.optionList instanceof Array)" v-for="(value,key) in col.optionList" :label="col.isNumber?Number(key):key">{{value}}</el-checkbox>
          </el-checkbox-group>

          <!--时间 type:5-->
          <el-date-picker :readonly="getFieldReadonly(col) || col.disabled"  v-if="col.type == 5" @input="change()" v-model="col.data" :type="col.dateType?col.dateType:'datetime'" :value-format="col.format?col.format:'timestamp'" :placeholder="col.title"></el-date-picker>

          <!--时间段 type:16-->
          <el-time-picker :readonly="getFieldReadonly(col) || col.disabled"  v-if="col.type == 16" @input="change()" v-model="col.data"  :value-format="col.format?col.format:'HH:mm:ss'" :placeholder="col.title"></el-time-picker>

          <!--富文本编辑器 type:6-->
          <quill  v-if="col.type == 6 && visible" :uploadUrl="col.uploadUrl" :quillId="col.field" ref="quill"></quill>
          <Ueditor v-if="col.type == 14 && visible" :col="col"></Ueditor>

          <!--计数器 type:7-->
          <el-input-number :disabled="getFieldReadonly(col)" v-if="col.type == 7" v-model="col.data" :min="col.min" :precision="col.precision" :label="col.title" :placeholder="col.placeholder ? col.placeholder : ''"></el-input-number>

          <!--分类多选框 type:8-->
          <el-checkbox-group :disabled="getFieldReadonly(col)"  v-if="col.type == 8"  @input="change()"  v-model="col.data" @change="(val)=>handleCheckedCitiesChangeMu(val,col)">
            <div v-for="select in col.selectList">
              <div>
                <el-checkbox :indeterminate="select.isIndeterminate"  v-model="select.checkAll" @change="(val)=>handleCheckAllChangeMu(val,select,col)" :label="select.check">{{select.checkAllName}}</el-checkbox>
              </div>
              <div style="margin:auto 20px" v-if="select.optionList">
                <el-checkbox v-if="select.optionList instanceof Array" v-for="option in select.optionList" :label="col.isNumber?Number(option.key):option.key">{{option.value}}</el-checkbox>
                <el-checkbox v-if="!(select.optionList instanceof Array)" v-for="(value,key) in select.optionList" :label="col.isNumber?Number(key):key">{{value}}</el-checkbox>
              </div>
              <div style="margin:auto 20px" v-if="select.styleList" v-for="optionList in select.styleList">
                <el-checkbox v-if="optionList instanceof Array" v-for="option in optionList" :label="col.isNumber?Number(option.key):option.key">{{option.value}}</el-checkbox>
                <el-checkbox v-if="!(optionList instanceof Array)" v-for="(value,key) in optionList" :label="col.isNumber?Number(key):key">{{value}}</el-checkbox>
              </div>
            </div>
          </el-checkbox-group>

          <!--开始结束时间 type:9-->
          <el-date-picker :range-separator="$t('page.to')"
                          :start-placeholder="col.title+$t('page.startTime')"
                          :end-placeholder="col.title+$t('page.endTime')" :readonly="getFieldReadonly(col)"  :disabled="col.disabled" v-if="col.type == 9" @input="change()" v-model="col.data"  type="datetimerange" :value-format="col.format?col.format:'timestamp'" :placeholder="col.title"></el-date-picker>

          <!--上传excel type:11-->
          <div v-if="col.type == 11">
            <el-upload
              :action="col.action || defaultUploadUrl"
              class="upload-demo"
              :data="col.option"
              :headers="uploadHeaders"
              drag
              :on-success="(response, file, fileList)=> uploadFileSuc(response, file, fileList,col)"
              :show-file-list="false"
              :auto-upload="true"
              :before-upload="(file)=> uploadFileProgress(file,col)">
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">{{$t('page.drag')}}<em>{{$t('page.clickUpload')}}</em></div>
              <span>{{col.loading}}</span>
            </el-upload>
            <el-input :readonly="col.readonly" v-model="col.fileName" v-if="col.showFileName !== false"></el-input>
            <el-button style="margin: 10px auto"  type="primary"  @click="downTemplate(col.downUrl)">{{$t('page.downTemplate')}}</el-button>
          </div>

          <!-- 图片上传组件 type:20-->
          <div v-if="col.upload || col.type == 20" class="upload-container">
            <el-upload
              :drag="col.drag"
              :data="col.option"
              :headers="uploadHeaders"
              class="upload-demo"
              :multiple="isMultiFileMode(col)"
              :auto-upload="isAutoUploadMode(col)"
              :on-success="(response, file, fileList)=> onUploadSuccess(response, file, fileList, col)"
              :on-change="(file, fileList) => onFileChange(file, fileList, col)"
              :on-remove="(file, fileList) => onFileRemove(file, fileList, col)"
              :action="col.action || defaultUploadUrl"
              :show-file-list="false"
              :before-upload="(file) => onBeforeUpload(file, col)">
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">{{$t('page.drag')}}<em>{{$t('page.clickUpload')}}</em></div>
              <span>{{col.loading}}</span>
            </el-upload>

            <!-- 图片预览区域 -->
            <div v-if="shouldShowPreview(col)" class="preview-container">
              <!-- 单文件预览 -->
              <template v-if="!isMultiFileMode(col) && hasFileData(col)">
                <div class="single-preview">
                  <!-- 显示URL图片（智能判断：编辑模式或自动上传模式） -->
                  <div v-if="shouldShowUrlImage(col, col.data)" class="url-preview">
                    <img class="preview-image" :src="col.data">
                    <div class="preview-actions">
                      <el-button size="mini" type="text" @click="clearSingleFile(col)">删除</el-button>
                    </div>
                  </div>
                  <!-- 显示文件预览（非自动上传模式的新选择文件） -->
                  <div v-else-if="isFileObject(col.data)" class="file-preview">
                    <img v-if="isImageFile(col.data)" class="preview-image" :src="getFilePreviewUrl(col.data)">
                    <div class="file-info">
                      <i class="el-icon-document"></i>
                      <span>{{ col.data.name }}</span>
                      <el-button size="mini" type="text" @click="clearSingleFile(col)">删除</el-button>
                    </div>
                  </div>
                </div>
              </template>

              <!-- 多文件预览 -->
              <template v-else-if="isMultiFileMode(col) && hasFileData(col)">
                <div class="multi-preview">
                  <!-- 显示混合数据：URL和文件 -->
                  <div v-for="(item, index) in getMixedDataList(col.data)" :key="`mixed-${index}`" class="preview-item">
                    <!-- URL图片预览 -->
                    <template v-if="isValidImageUrl(item)">
                      <img class="preview-image" :src="item">
                      <div class="preview-actions">
                        <el-button size="mini" type="text" @click="removeItemFromList(col, index)">删除</el-button>
                      </div>
                    </template>
                    <!-- 文件预览 -->
                    <template v-else-if="isFileObject(item)">
                      <img v-if="isImageFile(item)" class="preview-image" :src="getFilePreviewUrl(item)">
                      <div class="file-info">
                        <i class="el-icon-document"></i>
                        <span>{{ item.name }}</span>
                        <el-button size="mini" type="text" @click="removeItemFromList(col, index)">删除</el-button>
                      </div>
                    </template>
                  </div>
                </div>
              </template>
            </div>
          </div>

          <!--默认从变量 type:12-->
          <el-input :readonly="getFieldReadonly(col)" :disabled="col.disabled" :type="col.textType"  v-if="col.type == 12"   v-model="col.dataRender(updateModel,col)?col.data:col.data" :placeholder="col.placeholder==null?col.title:col.placeholder"></el-input>

          <!--select框 type:13-->
          <el-select :readonly="getFieldReadonly(col)" :disabled="col.disabled" :multiple="col.multiple" @input="change()" v-if="col.type == 13" v-model="col.dataRender(updateModel,col)?col.data:col.data" :placeholder="col.title">
            <el-option v-if="col.optionList && col.optionList instanceof Array" v-for="option in col.optionList" :label="option.value" :value="col.isNumber?Number(option.key):option.key"></el-option>
            <el-option v-if="col.optionList && !(col.optionList instanceof Array)" v-for="(value,key) in col.optionList" :label="value" :value="col.isNumber?Number(key):key"></el-option>
            <el-option v-if="col.optionListArrRender" v-for="option in (col.optionListArrRender?col.optionListArrRender(updateModel,col):[])" :label="option.value" :value="col.isNumber?Number(option.key):option.key"></el-option>
            <el-option v-if="col.optionListObjRender" v-for="(value,key) in (col.optionListObjRender?col.optionListObjRender(updateModel,col):{})" :label="value" :value="col.isNumber?Number(key):key"></el-option>
          </el-select>

          <!--cascader框 级联选择器 type:15-->
          <el-cascader v-if="col.type == 15"
                       v-model="col.data"
                       :options="col.optionList"
                       :props="{
                          expandTrigger: 'hover',
                          checkStrictly: col.checkStrictly ? col.checkStrictly : false,
                          multiple: col.multiple ? col.multiple : false,
                          emitPath: (col.emitPath != undefined && col.emitPath == false) ? col.emitPath : true
                      }"
                       filterable
                       clearable
                       :disabled="col.disabled"
                       :collapse-tags = "col.collapse ? col.collapse : false">
          </el-cascader>

          <!--table选择框 type:18-->
          <table-page v-if="col.type == 18" :ref="'childTable'+col.field"  @checkbox="(row) => checkbox(row,col)" :pageData="col.pageData"></table-page>

          <!--按钮-->
          <el-button style="margin:10px auto" type="primary" v-if="col.btn" @click="col.click(updateModel,col,formData.cols)">{{col.btn}}</el-button>

          <!-- 手机号掩码输入 type:19 -->
          <el-input
            v-else-if="col.type == 19"
            :value="col.displayValue"
            @input="handlePhoneInput($event, col)"
            @blur="handlePhoneBlur(col)"
            @focus="handlePhoneFocus(col)"
            :placeholder="col.placeholder?col.placeholder:'请输入11位手机号'"
            maxlength="11"
            :class="{'valid-phone': col.isValid, 'invalid-phone': !col.isValid && col.displayValue && col.displayValue.length > 0}"
          ></el-input>

        </el-form-item>

        <!--自定义slot type:10-->
        <slot v-if="col.type == 10||col.hidden?(typeof col.hidden == 'function'?!col.hidden(updateModel,col):true):true"
              :name="col.slot" :col="col" :updateModel="updateModel"></slot>
        <div v-if="col.remarkType&&col.remarkTxt!=''" class="remarkType">
          <span v-html="col.remarkTxt"></span>
        </div>
      </div>
    </el-form>
    <div v-show="!updateData.submit || updateData.submit == 'show'">
      <template  slot="footer" style="display: flex;justify-content: center;align-items: center;width: 100%">
        <el-button @click="close()">{{$t('page.cancel')}}</el-button>
        <el-button type="primary" @click="submit()" :disabled="submitBtn.disabled" :loading="submitBtn.loading">{{$t('page.submit')}}</el-button>
      </template>
    </div>

  </el-dialog>
</template>

<script>
import { getToken } from '@/utils/auth'
import { localRead, getQueryString } from '@/utils/tools'
import quill from "@/components/page/quill.vue"
import Url from "@/components/page/url"
import Ueditor from "@/components/page/ueditor.vue"
import tablePage from '@/components/page/table.vue'

export default {
  components: {
    quill,
    Ueditor,
    tablePage,
  },
  props: ["updateData"],
  data(){
    return{
      defaultUploadUrl: Url.img.upload,
      maxHeight: "",
      visible: false,
      formData: {cols: []},
      colData: {},
      uploadHeaders: {},
      submitBtn: {
        loading: false,
        disabled: false
      },
    }
  },
  computed: {
    updateModel: {
      get(){
        let obj = {};
        for (let i in this.formData.cols) {
          const col = this.formData.cols[i];

          if (col.type == 8) {
            let arr = col.data;
            for (let j in col.selectList) {
              arr = arr.filter((item) => {
                return item != col.selectList[j].check;
              });
            }
            obj[col.field] = arr;
          } else if (col.type == 9) {
            this.processDateRangeField(col, obj);
          } else {
            obj[col.field] = col.data;
          }
        }
        return obj;
      },
    }
  },
  methods: {
    // ===========================================
    // 表单字段状态计算方法
    // ===========================================

    /**
     * 获取字段是否必填
     */
    getFieldRequired(col) {
      return typeof col.required == 'function' ? col.required(this.updateModel, col) : col.required;
    },

    /**
     * 获取字段显示状态
     */
    getFieldDisplay(col) {
      const hidden = typeof col.hidden == 'function' ? col.hidden(this.updateModel, col) : col.hidden;
      return hidden ? 'none' : 'flex';
    },

    /**
     * 获取字段只读状态
     */
    getFieldReadonly(col) {
      return typeof col.readonly == 'function' ? col.readonly(this.updateModel, col) : col.readonly;
    },

    // ===========================================
    // 文件上传相关判断方法
    // ===========================================

    /**
     * 是否为自动上传模式
     */
    isAutoUploadMode(col) {
      return col.autoUpload !== false;
    },

    /**
     * 是否为多文件模式
     */
    isMultiFileMode(col) {
      return col.multiFile === true;
    },

    /**
     * 是否显示预览
     */
    shouldShowPreview(col) {
      return col.preview !== false && this.hasFileData(col);
    },

    /**
     * 是否有文件数据
     */
    hasFileData(col) {
      return col.data && (
        (this.isMultiFileMode(col) && Array.isArray(col.data) && col.data.length > 0) ||
        (!this.isMultiFileMode(col) && col.data)
      );
    },

    /**
     * 是否为字符串URL
     */
    isStringUrl(data) {
      return typeof data === 'string' && data.trim() !== '';
    },

    /**
     * 是否为文件对象
     */
    isFileObject(data) {
      return data && data instanceof File;
    },

    /**
     * 是否为有效的图片URL（支持http/https/data:image格式）
     */
    isValidImageUrl(url) {
      if (!this.isStringUrl(url)) return false;
      return /^(https?:\/\/|data:image\/|\/)/i.test(url);
    },

    /**
     * 是否应该显示URL图片（编辑模式智能判断）
     * 编辑时：无论上传模式如何，都显示已有URL
     * 新增时：根据上传模式判断
     */
    shouldShowUrlImage(col, data) {
      if (!this.isValidImageUrl(data)) return false;

      // 如果是自动上传模式，直接显示URL
      if (this.isAutoUploadMode(col)) return true;

      // 如果是非自动上传模式，但数据来源是编辑回显（原有数据），也应该显示
      // 通过判断是否为初始数据来区分
      return this.isInitialData(col, data);
    },

    /**
     * 判断是否为初始回显数据
     * 通过检查colData中是否包含此字段来判断是否为编辑模式的初始数据
     */
    isInitialData(col, data) {
      return this.colData && this.colData[col.field] === data;
    },

    /**
     * 获取URL列表（智能处理混合数据）
     */
    getUrlList(data) {
      if (!Array.isArray(data)) return [];
      return data.filter(item => this.isValidImageUrl(item));
    },

    /**
     * 获取文件列表（只返回File对象）
     */
    getFileList(data) {
      if (!Array.isArray(data)) return [];
      return data.filter(item => this.isFileObject(item));
    },

    /**
     * 获取混合数据列表（包含URL和File）
     */
    getMixedDataList(data) {
      if (!Array.isArray(data)) return [];
      return data.filter(item => this.isValidImageUrl(item) || this.isFileObject(item));
    },

    /**
     * 判断是否为图片文件
     */
    isImageFile(file) {
      return file && file.type && file.type.startsWith('image/');
    },

    /**
     * 获取文件预览URL
     */
    getFilePreviewUrl(file) {
      return file ? URL.createObjectURL(file) : '';
    },

    // ===========================================
    // 文件上传事件处理方法
    // ===========================================

    /**
     * 文件变化处理（非自动上传模式）
     */
    onFileChange(file, fileList, col) {
      if (!this.isAutoUploadMode(col)) {
        if (this.isMultiFileMode(col)) {
          // 多文件模式：合并新文件到现有数据
          if (!Array.isArray(col.data)) col.data = [];
          // 移除之前的File对象，保留URL
          col.data = col.data.filter(item => !this.isFileObject(item));
          // 添加新的文件对象
          const newFiles = fileList.map(item => item.raw).filter(Boolean);
          col.data = col.data.concat(newFiles);
        } else {
          // 单文件模式：直接替换
          col.data = file.raw;
        }
        this.$forceUpdate();
      }
    },

    /**
     * 文件移除处理
     */
    onFileRemove(file, fileList, col) {
      if (!this.isAutoUploadMode(col)) {
        if (this.isMultiFileMode(col)) {
          // 多文件模式：保留URL，只更新文件列表
          const urls = col.data.filter(item => this.isValidImageUrl(item));
          const newFiles = fileList.map(item => item.raw).filter(Boolean);
          col.data = urls.concat(newFiles);
        } else {
          // 单文件模式：如果移除的是新选择的文件，则恢复到初始状态或清空
          if (this.isFileObject(col.data)) {
            // 如果有初始URL，恢复到初始URL；否则清空
            col.data = this.colData && this.colData[col.field] ? this.colData[col.field] : null;
          }
        }
        this.$forceUpdate();
      }
    },

    /**
     * 上传成功处理（自动上传模式）
     */
    onUploadSuccess(response, file, fileList, col) {
      if (response.code == 0) {
        if (this.isMultiFileMode(col)) {
          // 多文件模式：添加新URL
          if (!Array.isArray(col.data)) col.data = [];
          col.data.push(response.result);
        } else {
          // 单文件模式：替换为新URL
          this.$set(col, "data", response.result);
        }
        col.loading = "";
      } else {
        col.loading = window.$t('page.uploadFail');
      }
      this.$forceUpdate();
    },

    /**
     * 上传前处理
     */
    onBeforeUpload(file, col) {
      col.loading = window.$t('page.uploading');
      this.$forceUpdate();
      return true;
    },

    // ===========================================
    // 文件删除方法
    // ===========================================

    /**
     * 清除单个文件
     */
    clearSingleFile(col) {
      col.data = null;
      this.$forceUpdate();
    },

    /**
     * 从混合数据列表中删除指定项（统一处理URL和文件）
     */
    removeItemFromList(col, index) {
      if (Array.isArray(col.data) && col.data[index] !== undefined) {
        col.data.splice(index, 1);
        this.$forceUpdate();
      }
    },

    /**
     * 从文件列表中删除指定文件（保持向后兼容）
     */
    removeFileFromList(col, index) {
      this.removeItemFromList(col, index);
    },

    /**
     * 从URL列表中删除指定URL（保持向后兼容）
     */
    removeUrlFromList(col, index) {
      const urlList = this.getUrlList(col.data);
      if (urlList[index]) {
        const targetUrl = urlList[index];
        const realIndex = col.data.indexOf(targetUrl);
        if (realIndex > -1) {
          col.data.splice(realIndex, 1);
          this.$forceUpdate();
        }
      }
    },

    // ===========================================
    // 数据处理辅助方法
    // ===========================================

    /**
     * 处理日期范围字段
     */
    processDateRangeField(col, obj) {
      if (!col.startEndParam) {
        obj[col.field + 'Start'] = col.data[0];
        obj[col.field + 'End'] = col.data[1];
      } else {
        obj[col.startEndParam[0]] = col.data[0];
        obj[col.startEndParam[1]] = col.data[1];
      }

      const value = col.isArray;
      if (typeof(value) == 'undefined' || value === '' || value == null || value == true) {
        obj[col.field] = col.data;
      } else {
        obj[col.field] = col.data.join(',');
      }
    },

    /**
     * 检查是否有文件上传
     */
    hasFileUpload() {
      return this.formData.cols.some(col =>
        col.upload && col.autoUpload === false && col.data
      );
    },

    /**
     * 构建提交数据
     */
    buildSubmitData() {
      const submitData = JSON.parse(JSON.stringify(this.updateModel));

      // 处理非自动上传的文件字段
      this.formData.cols.forEach(col => {
        if (col.upload && col.autoUpload === false && col.data) {
          submitData[col.field] = col.data;
        }
      });

      return submitData;
    },

    /**
     * 构建FormData对象
     */
    buildFormData(submitData) {
      const formData = new FormData();

      for (let field in submitData) {
        const value = submitData[field];
        if (value instanceof File) {
          formData.append(field, value);
        } else if (Array.isArray(value) && value.length > 0 && value[0] instanceof File) {
          value.forEach((file, index) => {
            formData.append(`${field}[${index}]`, file);
          });
        } else {
          if (value !== null && value !== undefined) {
            formData.append(field, value);
          }
        }
      }

      return formData;
    },

    // ===========================================
    // 原有方法（保持向后兼容）
    // ===========================================

    checkbox(row, col) {
      col.data = row;
    },

    cascaderOptionsNumber(options) {
      return options.map(obj => {
        obj.value = Number(obj.value);
        return obj;
      });
    },

    downTemplate(url) {
      window.location.href = url;
    },

    docHeight() {
      let docHeight = window.innerHeight || document.documentElement.clientHeight;
      this.maxHeight = docHeight / 1.8 + 'px';
    },

    loading() {
      this.changeSubmitBtnStatus(true);
    },

    beforeClose(done) {
      this.changeSubmitBtnStatus(false);
      if (this.updateData.beforeClose) {
        this.updateData.beforeClose(done);
      } else {
        done();
      }
    },

    close() {
      this.changeSubmitBtnStatus(false);
      this.visible = false;
    },

    open(data) {
      this.colData = data || {};
      this.visible = true;
      this.formData = {cols: []};
      this.formData.modelName = this.updateData.modelName;

      for (let i in this.updateData.cols) {
        let assign = Object.assign(this.common.copy(this.updateData.cols[i]));
        if (this.colData[this.updateData.cols[i].field] !== undefined) {
          assign.data = this.colData[this.updateData.cols[i].field];
        }
        this.formData.cols.push(assign);
      }

      // 处理多选框的全选回显样式
      for (let i in this.formData.cols) {
        if (this.formData.cols[i].type == 8) {
          this.handleCheckedCitiesChangeMu(this.formData.cols[i].data, this.formData.cols[i]);
        } else if (this.formData.cols[i].type == 4 && this.formData.cols[i].hasCheckAll) {
          this.handleCheckedCitiesChange(this.formData.cols[i].data, this.formData.cols[i]);
        }
      }

      this.$nextTick(() => {
        let index = 0;
        for (let i in this.formData.cols) {
          if (this.formData.cols[i].type == 6) {
            this.$refs.quill[index].init(this.formData.cols[i].data);
            index++;
          } else if (this.formData.cols[i].type == 18) {
            this.$refs['childTable' + this.formData.cols[i].field][0].initTableByData(this.formData.cols[i].optionList, this.formData.cols[i].selectList);
          }
        }
        this.initializePhoneFields();
      });
    },

    change() {
      this.$forceUpdate();
    },

    changeValue(updateModel, col, cols) {
      if (col.change instanceof Function) {
        col.change(updateModel, cols, col);
      }
    },

    changeSubmitBtnStatus(status) {
      this.$set(this.submitBtn, "loading", status);
      this.$set(this.submitBtn, "disabled", status);
    },

    submit() {
      // 处理富文本编辑器数据
      let index = 0;
      for (let i in this.formData.cols) {
        if (this.formData.cols[i].type == 6) {
          this.formData.cols[i].data = this.$refs.quill[index].getHtml();
          this.updateModel[this.formData.cols[i].field] = this.$refs.quill[index].getHtml();
          index++;
        }
        // 验证手机号
        if (this.formData.cols[i].type === 19 && this.formData.cols[i].required) {
          if (!/^1\d{10}$/.test(this.formData.cols[i].data)) {
            this.alert('手机号格式错误');
            return;
          }
        }
      }

      this.$forceUpdate();

      // 表单验证
      for (let i in this.formData.cols) {
        const required = this.getFieldRequired(this.formData.cols[i]);
        if (required) {
          const value = this.updateModel[this.formData.cols[i].field];
          if (Array.isArray(value)) {
            if (value.length <= 0) {
              this.alert(this.formData.cols[i].title, this.formData.cols[i].errorMsg);
              return;
            }
          } else {
            if (typeof(value) == 'undefined' || value === '' || value == null) {
              this.alert(this.formData.cols[i].title, this.formData.cols[i].errorMsg);
              return;
            }
          }
        }
      }

      if (this.updateData.submitTimeout) {
        this.changeSubmitBtnStatus(true);
      }

      // 构建并提交数据
      const submitData = this.buildSubmitData();

      if (this.hasFileUpload()) {
        const formData = this.buildFormData(submitData);
        this.$emit("submitWithFiles", formData);
      } else {
        this.$emit("submit", submitData);
      }
    },

    alert(title, errorMsg) {
      this.$alert(errorMsg || (window.$t('page.write') + title), window.$t('page.validate'), {
        confirmButtonText: window.$t('page.enter'),
        callback: action => {}
      });
    },

    // ===========================================
    // 原有上传相关方法（向后兼容）
    // ===========================================

    uploadSuc(response, file, fileList, col) {
      this.onUploadSuccess(response, file, fileList, col);
    },

    uploadProgress(file, col) {
      this.onBeforeUpload(file, col);
    },

    uploadFileSuc(response, file, fileList, col) {
      if (response.code == 0) {
        col.loading = "";
        this.$message.success(window.$t('page.uploadSuc'));
      } else {
        col.loading = window.$t('page.uploadFail');
      }
      this.$forceUpdate();
      this.$emit("uploadFile", col, response.result);
      this.$emit("uploadResult", col, response);
      this.$emit("uploadSuc", col, response.result, this.formData.cols);
    },

    uploadFileProgress(file, col) {
      col.loading = window.$t('page.uploading');
      col.fileName = file.name;
      this.$forceUpdate();
    },

    // ===========================================
    // 复选框相关方法（原有逻辑保持不变）
    // ===========================================

    pushArr(optionList, arr) {
      if (optionList instanceof Array) {
        for (let i in optionList) {
          arr.push(optionList[i].key);
        }
      } else {
        for (let i in optionList) {
          arr.push(i);
        }
      }
    },

    getCheckAllArr(col) {
      let optionList = [];
      if (col.optionList) {
        this.pushArr(col.optionList, optionList);
      } else if (col.styleList) {
        for (let i in col.styleList) {
          if (col.styleList[i]) {
            this.pushArr(col.styleList[i], optionList);
          }
        }
      }
      if (col.isNumber) optionList = optionList.map(key => Number(key));
      return optionList;
    },

    selectAllOrRemoveAll(dataArr, selectArr, type) {
      for (let i in selectArr) {
        if (type == 1) {
          if (dataArr.indexOf(selectArr[i]) == -1) {
            dataArr.push(selectArr[i]);
          }
        } else {
          dataArr = dataArr.filter((item) => {
            return item != selectArr[i];
          });
        }
      }
      return dataArr;
    },

    handleCheckAllChange(val, col) {
      let optionList = this.getCheckAllArr(col);
      col.data = val ? optionList : [];
      col.isIndeterminate = false;
      this.$forceUpdate();
    },

    handleCheckAllChangeMu(val, select, col) {
      let optionList = this.getCheckAllArr(select);
      if (col.isNumber) {
        col.data = col.data.map(key => Number(key));
        optionList = optionList.map(key => Number(key));
      }
      if (val) {
        col.data = this.selectAllOrRemoveAll(col.data, optionList, 1);
      } else {
        col.data = this.selectAllOrRemoveAll(col.data, optionList, 0);
      }
      select.isIndeterminate = false;
      this.$forceUpdate();
    },

    handleCheckedCitiesChangeMu(val, col) {
      let dataList = col.data;
      if (col.isNumber) dataList = col.data.map(key => Number(key));
      for (let i in col.selectList) {
        let optionList = this.getCheckAllArr(col.selectList[i]);
        if (col.isNumber) optionList = optionList.map(key => Number(key));
        let flag = true;
        let hasData = false;
        let check = [col.isNumber ? Number(col.selectList[i].check) : col.selectList[i].check];
        for (let j in optionList) {
          if (dataList.indexOf(optionList[j]) == -1) {
            flag = false;
            col.selectList[i].checkAll = false;
            col.data = this.selectAllOrRemoveAll(col.data, check, 0);
          } else {
            hasData = true;
          }
        }
        if (flag) {
          col.selectList[i].checkAll = true;
          col.data = this.selectAllOrRemoveAll(col.data, check, 1);
        }
        col.selectList[i].isIndeterminate = hasData && !flag;
      }
      this.$forceUpdate();
    },

    handleCheckedCitiesChange(val, col) {
      let optionList = this.getCheckAllArr(col);
      let checkedCount = val.length;
      col.checkAll = checkedCount === optionList.length;
      col.isIndeterminate = checkedCount > 0 && checkedCount < optionList.length;
      this.$forceUpdate();
    },

    // ===========================================
    // 手机号相关方法（保持不变）
    // ===========================================

    initializePhoneFields() {
      this.formData.cols.forEach(col => {
        if (col.type === 19) {
          const displayValue = col.data && /^\d{11}$/.test(col.data)
            ? this.maskPhone(col.data)
            : (col.data || '');
          this.$set(col, 'displayValue', displayValue);
        }
      });
    },

    maskPhone(phone) {
      return phone && phone.length === 11
        ? phone.replace(/(\d{3})(\d{4})(\d{4})/, '$1****$3')
        : phone;
    },

    handlePhoneBlur(col) {
      if (col.data && col.data.length === 11) {
        col.displayValue = this.maskPhone(col.data);
      }
    },

    handlePhoneFocus(col) {
      col.data = '';
      col.displayValue = col.data || '';
      col.isValid = false;
    },

    handlePhoneInput(value, col) {
      const cleanedValue = value.replace(/\D/g, '').slice(0, 11);
      col.data = cleanedValue;
      col.displayValue = cleanedValue;
      col.isValid = cleanedValue.length === 11;
    },
  },

  mounted() {
    this.docHeight();
    this.initializePhoneFields();

    if (localRead('sysToken')) {
      this.uploadHeaders.Authorization = localRead('sysToken');
    } else if (window.SITE_CONFIG['routerLabel']) {
      this.uploadHeaders.Authorization = getToken(window.SITE_CONFIG['routerLabel']);
    } else if (window.location.href.indexOf('label') != -1) {
      let labelRouter = getQueryString('label');
      this.uploadHeaders.Authorization = getToken(labelRouter);
    }
    this.$forceUpdate();
  }
}
</script>

<style>
.dv_update .el-form-item {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.dv_update .el-form-item__content {
  width: 80%;
}
.dv_update .newLine .el-form-item__content {
  width: 100%;
}
.dv_update .el-form-item.newLine {
  flex-wrap: wrap;
  justify-content: flex-start;
}
.dv_update .newLine .el-form-item__label {
  width: 100%;
  background: #fbfbfb;
  text-align: left;
  padding: 0 15px;
  border: solid 1px #e6e6e6;
}
.dv_update .el-upload-dragger {
  width: 200px;
}
.dv_update .el-dialog__footer {
  display: flex;
  justify-content: center;
  align-items: center;
}
#edui_fixedlayer {
  z-index: 9999999!important;
}
.remarkType {
  overflow: hidden;
  margin: -15px 0 22px;
}
.remarkType span {
  overflow: hidden;
  display: block;
  width: 80%;
  float: right;
  padding: 0 10px;
}
.valid-phone input {
  border-color: #67c23a;
}
.invalid-phone input {
  border-color: #f56c6c;
}

/* 图片预览样式 */
.upload-container {
  width: 100%;
}

.preview-container {
  margin-top: 10px;
}

.single-preview,
.multi-preview {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.preview-item,
.url-preview,
.file-preview {
  position: relative;
  text-align: center;
  border: 1px solid #ddd;
  border-radius: 4px;
  overflow: hidden;
}

.preview-image {
  width: 150px;
  height: 150px;
  object-fit: cover;
  display: block;
}

.preview-actions {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.6);
  padding: 5px;
  display: flex;
  justify-content: center;
}

.preview-actions .el-button {
  color: white;
  padding: 2px 8px;
  font-size: 12px;
}

.file-info {
  padding: 10px;
  font-size: 12px;
  color: #666;
  display: flex;
  align-items: center;
  gap: 5px;
  flex-wrap: wrap;
  background: #f5f5f5;
}

.file-info .el-button {
  margin-left: auto;
  color: #409eff;
}

.file-info i {
  font-size: 16px;
  color: #909399;
}
</style>
